import React, {forwardRef, useImperativeHandle, useState, useRef, useEffect} from 'react'
import {Checkbox, Input, message, Pagination, Radio} from "antd";
import AddDeviceList from "./AddDeviceList";
import Tools from '../tools/Tools'
import SimpleTreeUpdate from "./tree/mic/simpleTreeUpdate";
import AuthButton from "./antdReset/AuthButton";
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
function BatchCarSelect(props,ref) {
    const [type, setType] = useState('0')
    const [checkedAll, setCheckedAll] = useState(false)
    const [isTakeSub, setIsTakeSub] = useState(false)
    const [content, setContent] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [deviceCount, setDeviceCount] = useState(0)
    const [deviceList, setDeviceList] = useState([])
    const [selectedDeviceList, setSelectedDeviceList] = useState([])
    const [instructTypeList, setInstructTypeList] = useState([])
    const [accountId, setAccountId] = useState(props.accountId)
    const [listKey,setListKey] = useState(Tools.getKeyCode(props.platform))

    const deviceListDom = useRef(null)
    const simple = useRef(null)

    useImperativeHandle(ref, () => ({
        getDeviceList:(current,takeSub,id)=>{
            // getDeviceList(current,takeSub,id)
        },
        getSelectedDeviceList: () => {
            return selectedDeviceList
        },
        setSelectedDeviceList:(deviceList)=>{
            setSelectedDeviceList(deviceList)
            deviceListDom.current.addDevices(deviceList)
        },
        reset:()=>{
            setSelectedDeviceList([])
            deviceListDom.current.resetAddDeviceListStateInfo()
            setCheckedAll(false)
            setIsTakeSub(false)
            setType('0')
        },
        reLoadSubTree:(accountId)=>{
            simple.current.setState({
                accountId
            })
           /* if (type == '0') {
                getDeviceList()
            }*/
        },
        isDetail:()=>{
            setType('1')
        }
    }))
    useEffect(()=>{
        if (type == '0') {
            getDeviceList()
        }
        simple.current.updateDatas_simple({
            treeVisible:false,
            popVisible:false,
            showSelect:true,
            expandKeys:[localStorage.getItem("organizationId").toString()],
            organizationName:Strings.selectorg || "请选择门店",
            selectedKeys:[localStorage.getItem("organizationId").toString()],
            organizationId:"",
            showRootName:false,
            isTallTree:true
        });
    },[])
    useEffect(() => {
        getDeviceList(currentPage)
    }, [currentPage]);
    function getDeviceList(current,takeSub,id) {
        //todo mic的需要单独获取
        let url = `${Tools.getApiUrl("devicesList",props.platform)}?`
        let urlCount = `${Tools.getApiUrl("devicesCount",props.platform)}?`;
        let type = "GET";
        let model = {};
        type = "POST";
        model ={
            content,
            currentPage:currentPage,
            pageSize:10,
            orgId:id||accountId,
            isTakeSub:!Tools.isNull(takeSub)?Number(takeSub):Number(isTakeSub)
        }

        Tools.fetch(url,type,model, (data) => {
            if(data.code === 0) {
                setDeviceList(data.data)
                setCheckedAll(false)
            } else {
                message.error(data.message)
            }
        })
        Tools.fetch(urlCount,type,model, (data)=> {
            if(data.code === 0) {
                setDeviceCount(data.data)
            } else {
                message.error(data.message)
            }
        })
    }

    function handleType(value) {
        setType(value)
        if (value == '1') {
            deviceListDom.current.addDevices(selectedDeviceList)
        }
    }

    function  handleTargetAccountChange(id, nodeName) {
        setAccountId(id)
        setCurrentPage(1)
        getDeviceList(1,isTakeSub,id)
    }

    function handleImeiSet(imeis) {
        let newSelectedDevices = JSON.parse(JSON.stringify(selectedDeviceList)).concat(imeis)
        let newList = Array.from(new Set(newSelectedDevices))
        setSelectedDeviceList(newList)
    }

    function handelDeleteImei(delItem) {
        let newSelectedDevices = JSON.parse(JSON.stringify(selectedDeviceList))
        let index = newSelectedDevices.findIndex((t) => t === delItem)
        newSelectedDevices.splice(index,1)
        console.log(index,newSelectedDevices)
        setSelectedDeviceList(newSelectedDevices)

    }

    function checkAllHandle(value) {
        setCheckedAll(value)
        let newSelectedDevices = JSON.parse(JSON.stringify(selectedDeviceList))
        let imeis = [] //用于存储取消勾选的设备号
        deviceList.map(function (item) {
            if (value) {
                let temp_value = item[listKey];
                newSelectedDevices.push(temp_value)
            }
            imeis.push(item[listKey])
        })
        if (!value) {
            imeis.map(function (imei_carCode) {
                let index = newSelectedDevices.findIndex(item=>{
                    return item == imei_carCode
                })
                newSelectedDevices.splice(index,1)
            })
        }
        let newList = Array.from(new Set(newSelectedDevices))
        setSelectedDeviceList(newList)

    }

    function handleDeviceChecked(value,checkedItem) {
        let newSelectedDevices = JSON.parse(JSON.stringify(selectedDeviceList))
        if(value) {
            newSelectedDevices.push(checkedItem)
        } else {
            let index = newSelectedDevices.findIndex(item=>{
                return item === checkedItem
            })
            newSelectedDevices.splice(index,1)
        }
        let newList = Array.from(new Set(newSelectedDevices))
        setSelectedDeviceList(newList)
    }

    let deviceItems = deviceList.map(function (item) {
        return <div className="instruct_device">
            <Checkbox className={"instruct_select_car_item"} style={{top:"auto"}} checked={selectedDeviceList.indexOf(item[listKey])>=0} onChange={(e)=>{
                handleDeviceChecked(e.target.checked,item[listKey])
            }}>
                <span className="device_name">{item.carCode}</span>
            </Checkbox>
        </div>
    })

    return  <div className="device_content">
        <RadioGroup onChange={(e)=>handleType(e.target.value)} value={type} className="mgb13">
            <RadioButton value="0">{Strings.rs14361}</RadioButton>
            <RadioButton value="1">{Strings.inputVin}</RadioButton>
        </RadioGroup>
        <div className={`emailPushModal ${type == '0'?'un_hidden':'hidden'}`}>
            <div className="instruct_select_tree tree_wrapper" style={{display:"flex",position:"relative",alignItems:"center"}}>
                <label className={"mgr10"}> {Strings.curOrg}</label>
              <SimpleTreeUpdate ref={simple} selectWidth={240}
                                margins={"5px auto"}
                                parentClass={`instruct_select_tree`}
                                directShowTree={false}
                                showRootName={true}
                                organizationId={props.accountId}
                                ownerName={props.accountName}
                                handleChange={handleTargetAccountChange}
                                sendAccountId={handleTargetAccountChange}/>

            </div>
            <div className="mgb10">
                <Checkbox className="buttons" checked={Boolean(isTakeSub)}
                          onChange={(e) => {
                              setIsTakeSub(Number(e.target.checked))
                              getDeviceList(currentPage,Number(e.target.checked))
                          }}>
                    {Strings.rs10597 || Strings.takeSub}</Checkbox>
            </div>
            <div className="emailPushDevice">
                <div className="component_header">{Strings.rs14361}</div>
                <div className="sider" >
                    <div className={'topSearch'}>
                        <div className="mgr10">
                            <Checkbox
                                checked={checkedAll}
                                onChange={(e) => {
                                    checkAllHandle(e.target.checked)
                                }}/>
                        </div>
                        <div className="detail_search">
                            <Input className="serach_input"
                                   placeholder={Strings.inputMachineCodeOrImei}
                                   value={content}
                                   onChange={(e)=>setContent(e.target.value.trim())}/>
                            <AuthButton authKey={true} className={"mgl20"}  type="primary" onClick={()=>{
                                setCurrentPage(1)
                                getDeviceList(1)}
                            }>{Strings.search}</AuthButton>
                        </div>
                    </div>
                    <div className="flex">
                        <div id="device_list_dive">
                            {deviceItems}
                        </div>
                        <Pagination
                            simple
                            defaultCurrent={1}
                            current={currentPage}
                            pageSize={10}
                            onChange={(current)=>{
                                setCurrentPage(current)
                            }} total={deviceCount}/>
                    </div>
                </div>
            </div>
        </div>
        <div className={`${type == '1'?'un_hidden':'hidden'}`}>
            <AddDeviceList  threeDele='-1' platform={props.platform}
                            max={500}
                            type={5}
                            isInstruct={true}
                            handleDelete={handelDeleteImei}
                            ref={deviceListDom} isModal={true}
                            handleImeiSet={handleImeiSet}/>
        </div>
    </div>

}
export default forwardRef(BatchCarSelect)